import React, { useState, useEffect } from "react";
import "../Assets/Styles.css";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";
import MenuItem from "@material-ui/core/MenuItem";
import InputLabel from "@material-ui/core/InputLabel";
import {
  SeasonsList,
  PlantsType,
  PlantsEvent,
} from "../context/GlobalVariables";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

function SeasonPredict() {
  const [PredictForm, setPredictForm] = React.useState({
    Season: "",
    Yesterday: "",
    Today: "",
    Plant: "",
    Risk: 50,
  });
  const [EventsYesterday, setEventsYesterday] = useState([]);
  const [EventsToday, setEventsToday] = useState([]);
  const [PosibleEvents, setPosibleEvents] = useState([]);
  const [EventBenefit, setEventBenefit] = useState([]);
  const [Probability, setProbability] = useState({
    ProbPos: 0,
    ProbNeg: 0,
    ProbNeu: 0,
    GreenHouse: true,
  });
  useEffect(() => {
    console.log("Benefit Array", EventBenefit);
    Calculate();
  }, [EventBenefit, PosibleEvents, EventsToday, EventsYesterday, PredictForm]);

  const Calculate = () => {
    var Total = EventBenefit.length;
    var percentage = 100 / Total;
    var Positive = (
      percentage * EventBenefit.filter((event) => event.Benefit > 0).length
    ).toFixed(1);
    var Neutral = (
      percentage * EventBenefit.filter((event) => event.Benefit == 0).length
    ).toFixed(1);
    var Negative = (
      percentage * EventBenefit.filter((event) => event.Benefit < 0).length
    ).toFixed(1);
    var Greenhouseneeded = true;
    if (Negative > Positive || Negative > PredictForm.Risk) {
      Greenhouseneeded = true;
    } else {
      Greenhouseneeded = false;
    }
    setProbability({
      ProbPos: Positive,
      ProbNeu: Neutral,
      ProbNeg: Negative,
      GreenHouse: Greenhouseneeded,
    });
    console.log(Probability);
  };

  const HandleSeason = (event) => {
    var Season = event.target.value;
    setPredictForm({ ...PredictForm, Season: Season });
    console.log(SeasonsList.find((item) => item.Name == Season));
    setEventsYesterday(
      SeasonsList.find((item) => item.Name == Season).EventsList
    );
    console.log(SeasonsList.find((item) => item.Name == Season).EventsList);
    console.log(PredictForm);
  };
  const HandleEventYesterday = (event) => {
    setPredictForm({ ...PredictForm, Yesterday: event.target.value });
    var Today = EventsYesterday.filter((item) => {
      return item != event.target.value;
    });
    setEventsToday(Today);
    console.log(Today);
    console.log(PredictForm);
  };

  const HandleEventToday = (event) => {
    setPredictForm({ ...PredictForm, Today: event.target.value });
    var Posible = EventsToday.filter((item) => {
      return item != event.target.value;
    });
    setPosibleEvents(Posible);
    console.log(PredictForm);
  };
  const HandleEventPlant = (event) => {
    var Plant = event.target.value;
    setPredictForm({ ...PredictForm, Plant: event.target.value });
    var BenefitArray = PosibleEvents.map((item) => {
      return {
        Name: item,
        Benefit:
          100 *
          PlantsEvent.find((e) => e.Name === Plant)[item.replace(" ", "")],
      };
    });
    setEventBenefit(BenefitArray);
    console.log(PredictForm);
  };
  const HandleTextChange = (Value, Field) => {
    setPredictForm({ ...PredictForm, [Field]: Value });
    console.log(PredictForm);
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        width: "100%",
        flexWrap: "wrap",
        justifyContent: "space-around",
      }}
    >
      <FormControl style={{ margin: "10px", minWidth: "24%", flexGrow: "1" }}>
        <InputLabel htmlFor="age-native-simple">Season</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          onChange={HandleSeason}
        >
          <MenuItem value={"Spring"} key={1}>
            {"Spring"}
          </MenuItem>
          <MenuItem value={"Summer"} key={2}>
            {"Summer"}
          </MenuItem>
          <MenuItem value={"Autumn"} key={3}>
            {"Autumn"}
          </MenuItem>
          <MenuItem value={"Winter"} key={4}>
            {"Winter"}
          </MenuItem>
        </Select>
      </FormControl>

      <FormControl style={{ margin: "10px", minWidth: "190px", flexGrow: "1" }}>
        <InputLabel htmlFor="age-native-simple">Yesterday</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={PredictForm.Yesterday}
          onChange={HandleEventYesterday}
        >
          {EventsYesterday.map((element, i) => {
            return (
              <MenuItem value={element} key={i}>
                {element}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <FormControl style={{ margin: "10px", minWidth: "190px", flexGrow: "1" }}>
        <InputLabel htmlFor="age-native-simple">Today</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={PredictForm.Today}
          onChange={HandleEventToday}
        >
          {EventsToday.map((element, i) => {
            return (
              <MenuItem value={element} key={i}>
                {element}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>

      <FormControl style={{ margin: "10px", minWidth: "24%", flexGrow: "1" }}>
        <InputLabel htmlFor="age-native-simple">Plant</InputLabel>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          value={PredictForm.Plant}
          onChange={HandleEventPlant}
        >
          {PlantsType.map((element, i) => {
            return (
              <MenuItem value={element} key={i}>
                {element}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
      <TextField
        style={{ margin: "10px", minWidth: "24%", flexGrow: "1" }}
        id="standard-read-only-input"
        label="Risk %"
        defaultValue="20"
        type="number"
        onChange={(event) => {
          HandleTextChange(event.target.value, "Risk");
        }}
      />
      <div
        style={{
          margin: "10px",
          minWidth: "24%",
          maxHeight: "48px",
          flexGrow: "1",
        }}
      >
        {
          (console.log(Probability.GreenHouse),
          Probability.GreenHouse == true ? (
            <Typography
              variant="h6"
              style={{ color: "green", margin: "auto", fontSize: "1.12rem" }}
            >
              USE A GREENHOUSE
            </Typography>
          ) : (
            <Typography
              variant="h6"
              style={{ color: "red", margin: "auto", fontSize: "1.12rem" }}
            >
              DO NOT USE A GREENHOUSE
            </Typography>
          ))
        }
      </div>
      <div style={{ height: "48px", margin: "10px", width: "90%" }}>
        <table className="GeneratedTable">
          <thead>
            <tr>
              <th style={{ backgroundColor: "green", color: "white" }}>
                Prob. Positive
              </th>
              <th style={{ backgroundColor: "navy", color: "white" }}>
                Prob. Neutral
              </th>
              <th style={{ backgroundColor: "red", color: "white" }}>
                Prob. Negative
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style={{ backgroundColor: "green", color: "white" }}>
                {Probability.ProbPos}%
              </td>
              <td style={{ backgroundColor: "navy", color: "white" }}>
                {Probability.ProbNeu}%
              </td>
              <td style={{ backgroundColor: "red", color: "white" }}>
                {Probability.ProbNeg}%
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
}

export default SeasonPredict;
